import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import CommonEditView from "./components/CommonEditView/index";
import useAlert from "~/common/hooks/useAlert";
import { getTitle } from "~/utils/getTitle";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const PortfolioEdit = () => {
	const navigate = useNavigate();
	const params = useParams();
	const { idx } = params;
	const industryRequest = useRequest("get", "vc/portfolio/industry");
	const portfolioDetailRequest = useRequest("get", `/vc/portfolio/detail/${idx}`);
	const portfolidEditRequest = useRequest("post", "vc/portfolio/edit");
	const [showAddSuccessAlert, AddSuccessAlert] = useAlert();
	const [portfolio, setPortfolio] = useState({});
	const [industryOptions, setIndustryOptions] = useState([]);

	const { t } = useTranslation();

	const handleSave = (data) => {
		data = {
			...data,
			StartupProduct: data.StartupProduct
				? data.StartupProduct.map((product) => {
						return {
							...product,
							keywordDelete: [],
							imageDelete: [],
						};
				  })
				: [],
		};
		// debugger;

		const deletedIndustries = [];
		const deletedKeywords = [];
		const deletedInvests = [];
		const deletedVcInvests = [];
		const deletedVcWithdraw = [];
		const deletedProducts = [];
		portfolio?.StartupIndustry?.forEach((pk) => {
			const exist = data?.Industry?.find((dk) => dk === pk?.industryIdx);
			if (!exist) deletedIndustries.push(pk.idx);
		});
		portfolio?.StartupKeyword?.forEach((pk) => {
			const exist = data?.StartupKeyword?.find((dk) => dk === pk?.title);
			if (!exist) deletedKeywords.push(pk.idx);
		});
		portfolio?.StartupInvest?.forEach((pk) => {
			const exist = data?.StartupInvest?.find((dk) => dk?.idx === pk?.idx);
			if (!exist) deletedInvests.push(pk.idx);
		});
		portfolio?.VcInvest?.forEach((pk) => {
			const exist = data?.VcInvest?.find((dk) => dk?.idx === pk?.idx);
			if (!exist) deletedVcInvests.push(pk.idx);
		});
		portfolio?.VcWithdraw?.forEach((pk) => {
			const exist = data?.VcWithdraw?.find((dk) => dk?.idx === pk?.idx);
			if (!exist) deletedVcWithdraw.push(pk.idx);
		});
		portfolio?.StartupProduct?.forEach((pk) => {
			const exist = data?.StartupProduct?.find((dk) => dk?.idx === pk?.idx);
			if (!exist) deletedProducts.push(pk.idx);
			if (exist) {
				pk?.Keyword.forEach((pki) => {
					const existKeyword = exist?.keyword.find((exi) => exi === pki.title);
					if (!existKeyword) exist.keywordDelete.push(pki.idx);
				});
				pk?.Image.forEach((pki) => {
					const existImage = exist?.image.find((exi) => exi === pki.imgUrl);
					if (!existImage) exist.imageDelete.push(pki.idx);
				});
			}
		});

		const formData = {
			...data,
			idx: parseInt(idx, 10),
			IndustryDelete: deletedIndustries,
			StartupProductDelete: deletedProducts,
			StartupKeywordDelete: deletedKeywords,
			StartupInvestDelete: deletedInvests,
			VcInvestDelete: deletedVcInvests,
			VcWithdrawDelete: deletedVcWithdraw,
		};
		console.log("editFormData", formData);
		// debugger;
		portfolidEditRequest.call(formData);
	};
	useEffect(() => {
		switch (portfolidEditRequest.state) {
			case API_STATE.done:
				showAddSuccessAlert().then(() => {
					navigate(`/portfolio/view/${idx}`);
				});
				break;
			default:
				break;
		}
	}, [portfolidEditRequest.state, portfolidEditRequest.response]);

	useEffect(() => {
		industryRequest.asyncCall().then((res) => {
			const { data } = res;
			setIndustryOptions(data);
		});
		portfolioDetailRequest.singleCall();
	}, []);

	useEffect(() => {
		switch (portfolioDetailRequest.state) {
			case API_STATE.done:
				const { portfolio } = portfolioDetailRequest.response?.data;
				setPortfolio(portfolio);
				break;
			default:
				break;
		}
	}, [portfolioDetailRequest.state, portfolioDetailRequest.response]);

	return (
		<>
			<Helmet>
				<title>{getTitle(t("pages.portfolio.PortfolioEdit.modPortfolio"))}</title>
			</Helmet>
			<CommonEditView
				portfolio={portfolio}
				industryOptions={industryOptions}
				onSave={handleSave}
			/>
			<AddSuccessAlert
				type="success"
				message={t("pages.portfolio.PortfolioEdit.modSucessful")}
				confirm={t("pages.portfolio.PortfolioEdit.confirm")}
			/>
		</>
	);
};

export default PortfolioEdit;
